"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactHookForm = require("react-hook-form");
var _reactComponents = require("@ui-propulsion/react-components");
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
require("./styles.scss");
var SelectInputControlled = function SelectInputControlled(_ref) {
  var control = _ref.control,
    name = _ref.name,
    options = _ref.options,
    placeholder = _ref.placeholder,
    isRequired = _ref.isRequired;
  var _useController = (0, _reactHookForm.useController)({
      name: name,
      control: control,
      rules: {
        validate: function validate(v) {
          if (isRequired && !v || v.length < 1) {
            return 'Selecting an option is required';
          }
          return true;
        }
      },
      defaultValue: ''
    }),
    field = _useController.field,
    error = _useController.fieldState.error;
  var selectClasses = (0, _classnames.default)('select-input', {
    'select-input--error': error
  });
  return /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    container: true,
    direction: "column",
    justifyContent: "flex-start"
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    item: true,
    xs: 12,
    md: 7
  }, /*#__PURE__*/_react.default.createElement("label", {
    id: "select-label",
    htmlFor: name
  }, placeholder, isRequired && /*#__PURE__*/_react.default.createElement("i", {
    className: "required-indicator"
  }, "*")), /*#__PURE__*/_react.default.createElement("select", Object.assign({
    id: name,
    "aria-invalid": !!error,
    className: selectClasses,
    "aria-labelledby": "select-label",
    "data-test-id": name
  }, field), /*#__PURE__*/_react.default.createElement("option", {
    value: "",
    disabled: true
  }, "-- Select one option --"), options.map(function (o) {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: o.id,
      value: o.value
    }, o.label);
  })), !!error && /*#__PURE__*/_react.default.createElement("label", {
    className: "input--error",
    role: "alert",
    htmlFor: name
  }, error.message)));
};
SelectInputControlled.defaultProps = {
  options: [],
  isRequired: false
};
SelectInputControlled.propTypes = {
  control: (0, _propTypes.shape)({}).isRequired,
  name: _propTypes.string.isRequired,
  options: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    value: _propTypes.number.isRequired,
    id: _propTypes.number.isRequired,
    label: _propTypes.string.isRequired
  })),
  placeholder: _propTypes.string.isRequired,
  isRequired: _propTypes.bool
};
var _default = exports.default = SelectInputControlled;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-refunds/lib/components/SelectInputControlled/styles.scss');